module.exports = __webpack_public_path__ + "static/media/carlos_eugenio.9475c86d.jpg";